import { useState } from 'react';
import { useSelector } from 'react-redux';

import {
  FlexJustifyCenter,
  StructureLeftRightWrapper
} from '../../../MyTeamBackofficeStyled';

import { Position } from '../../../myTeamBackOffice.constants';
import { DotLineArrows } from '../../common';
import { LevelZero } from './LevelZero/LevelZero';
import StructureNav from './StructureNav';
import { LevelTwo } from '../common/LevelTwo/LevelTwo';
import { LevelOne } from '../common/LevelOne/LevelOne';

const StructureDesktop = ({ selectTab }) => {
  const { rootTeamMemberTrading, rootTeamMemberInfoTrading } = useSelector(
    (store) => store.myTeamBackoffice
  );

  return (
    <>
      <FlexJustifyCenter>
        <LevelZero
          teamMember={rootTeamMemberTrading}
          teamMemberInfo={rootTeamMemberInfoTrading}
        />
      </FlexJustifyCenter>
      <DotLineArrows />
      <StructureLeftRightWrapper
        style={{ marginBottom: '80px', marginTop: 20 }}>
        <div>
          <LevelOne
            teamMember={rootTeamMemberTrading?.leftChildUser}
            parentId={rootTeamMemberTrading?.id}
            position={Position.L}
            selectTab={selectTab}
          />
          <DotLineArrows disabled={!rootTeamMemberTrading?.leftChildUser?.id} />

          <StructureLeftRightWrapper>
            <div>
              <LevelTwo
                teamMember={rootTeamMemberTrading?.leftChildUser?.leftChildUser}
                parentId={rootTeamMemberTrading?.leftChildUser?.id}
                position={Position.L}
                selectTab={selectTab}
              />
              <DotLineArrows
                disabled={
                  !rootTeamMemberTrading?.leftChildUser?.leftChildUser?.id
                }
              />
              <StructureLeftRightWrapper>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMemberTrading?.leftChildUser?.leftChildUser
                        ?.leftChildUser
                    }
                    parentId={
                      rootTeamMemberTrading?.leftChildUser?.leftChildUser?.id
                    }
                    position={Position.L}
                    selectTab={selectTab}
                  />
                </div>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMemberTrading?.leftChildUser?.leftChildUser
                        ?.rightChildUser
                    }
                    parentId={
                      rootTeamMemberTrading?.leftChildUser?.leftChildUser?.id
                    }
                    position={Position.R}
                    selectTab={selectTab}
                  />
                </div>
              </StructureLeftRightWrapper>
            </div>
            <div>
              <LevelTwo
                teamMember={
                  rootTeamMemberTrading?.leftChildUser?.rightChildUser
                }
                parentId={rootTeamMemberTrading?.leftChildUser?.id}
                position={Position.R}
                selectTab={selectTab}
              />
              <DotLineArrows
                disabled={
                  !rootTeamMemberTrading?.leftChildUser?.rightChildUser?.id
                }
              />
              <StructureLeftRightWrapper>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMemberTrading?.leftChildUser?.rightChildUser
                        ?.leftChildUser
                    }
                    parentId={
                      rootTeamMemberTrading?.leftChildUser?.rightChildUser?.id
                    }
                    position={Position.L}
                    selectTab={selectTab}
                  />
                </div>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMemberTrading?.leftChildUser?.rightChildUser
                        ?.rightChildUser
                    }
                    parentId={
                      rootTeamMemberTrading?.leftChildUser?.rightChildUser?.id
                    }
                    position={Position.R}
                    selectTab={selectTab}
                  />
                </div>
              </StructureLeftRightWrapper>
            </div>
          </StructureLeftRightWrapper>
        </div>

        {/* // */}

        <div>
          <LevelOne
            teamMember={rootTeamMemberTrading?.rightChildUser}
            parentId={rootTeamMemberTrading?.id}
            position={Position.R}
            selectTab={selectTab}
          />
          <DotLineArrows
            disabled={!rootTeamMemberTrading?.rightChildUser?.id}
          />

          <StructureLeftRightWrapper>
            <div>
              <LevelTwo
                teamMember={
                  rootTeamMemberTrading?.rightChildUser?.leftChildUser
                }
                parentId={rootTeamMemberTrading?.rightChildUser?.id}
                position={Position.L}
                selectTab={selectTab}
              />
              <DotLineArrows
                disabled={
                  !rootTeamMemberTrading?.rightChildUser?.leftChildUser?.id
                }
              />
              <StructureLeftRightWrapper>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMemberTrading?.rightChildUser?.leftChildUser
                        ?.leftChildUser
                    }
                    parentId={
                      rootTeamMemberTrading?.rightChildUser?.leftChildUser?.id
                    }
                    position={Position.L}
                    selectTab={selectTab}
                  />
                </div>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMemberTrading?.rightChildUser?.leftChildUser
                        ?.rightChildUser
                    }
                    parentId={
                      rootTeamMemberTrading?.rightChildUser?.leftChildUser?.id
                    }
                    position={Position.R}
                    selectTab={selectTab}
                  />
                </div>
              </StructureLeftRightWrapper>
            </div>
            <div>
              <LevelTwo
                teamMember={
                  rootTeamMemberTrading?.rightChildUser?.rightChildUser
                }
                parentId={rootTeamMemberTrading?.rightChildUser?.id}
                position={Position.R}
                selectTab={selectTab}
              />
              <DotLineArrows
                disabled={
                  !rootTeamMemberTrading?.rightChildUser?.rightChildUser?.id
                }
              />
              <StructureLeftRightWrapper>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMemberTrading?.rightChildUser?.rightChildUser
                        ?.leftChildUser
                    }
                    parentId={
                      rootTeamMemberTrading?.rightChildUser?.rightChildUser?.id
                    }
                    position={Position.L}
                    selectTab={selectTab}
                  />
                </div>
                <div>
                  <LevelTwo
                    teamMember={
                      rootTeamMemberTrading?.rightChildUser?.rightChildUser
                        ?.rightChildUser
                    }
                    parentId={
                      rootTeamMemberTrading?.rightChildUser?.rightChildUser?.id
                    }
                    position={Position.R}
                    selectTab={selectTab}
                  />
                </div>
              </StructureLeftRightWrapper>
            </div>
          </StructureLeftRightWrapper>
        </div>
      </StructureLeftRightWrapper>
      <StructureNav selectTab={selectTab} />
    </>
  );
};

export default StructureDesktop;
